
import { replicate as replicate_1, fold, reverse, mapIndexed, collect, sort, map, append as append_1, splitAt, concat, ofArray, cons, tryPick, getSlice, tail, skipWhile, head, isEmpty, item, length, empty, singleton } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { XYPos } from "../Common/CommonTypes.js";
import { Interval_$reflection, Model, Msg, EditorMsg, Interval, CodeEditorModel } from "../Model/ModelType.js";
import { defaultOf, int32ToString, compareArrays, equals, sign } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { min, max } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { Record, MatchFailureException, Union } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { record_type, list_type, option_type, string_type, int32_type, union_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { removeAt, singleton as singleton_1, append, delay, toList, indexed, forAll } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { replicate, printf, toText, insert, join } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { isDigit, isLetter, isLetterOrDigit } from "../fable_modules/fable-library-js.5.13.0/Char.js";
import { warnOnce } from "../Shared/Log.js";
import { value, toArray, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { DOMAttr, HTMLAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react from "react";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../fable_modules/Fable.React.9.4.0/Fable.React.FunctionComponent.fs.js";
import { Helpers_equalsButFunctions } from "../fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";

export const Constants_leftMargin = 100;

export const Constants_leftGutter = 20;

export const initCodeEditorState = new CodeEditorModel(singleton(""), empty(), new XYPos(0, 0));

/**
 * Returns the intersection of two intervals each defining the end points
 * of a raster scan (ascending order X first then Y), or None if there is no intersection.
 */
export function intersectionOpt(other, this$) {
    let startPos;
    const matchValue = sign(this$.Start.Y - other.Start.Y) | 0;
    startPos = ((matchValue === -1) ? other.Start : ((matchValue === 0) ? (new XYPos(max(this$.Start.X, other.Start.X), this$.Start.Y)) : this$.Start));
    let endPos;
    const matchValue_1 = sign(this$.End.Y - other.End.Y) | 0;
    endPos = ((matchValue_1 === -1) ? this$.End : ((matchValue_1 === 0) ? (new XYPos(min(this$.End.X, other.End.X), this$.End.Y)) : other.End));
    if ((startPos.Y > endPos.Y) ? true : ((startPos.Y === endPos.Y) && (startPos.X > endPos.X))) {
        return undefined;
    }
    else {
        return new Interval(startPos, endPos);
    }
}

/**
 * the type of the code editor's text string asociated with a given highlight color
 */
export class HighlightT extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Normal", "Keyword", "Identifier", "Number", "String"];
    }
    static Normal = new HighlightT(0, []);
    static Keyword = new HighlightT(1, []);
    static Identifier = new HighlightT(2, []);
    static Number$ = new HighlightT(3, []);
    static String$ = new HighlightT(4, []);
}

export function HighlightT_$reflection() {
    return union_type("Editor.HighlightT", [], HighlightT, () => [[], [], [], [], []]);
}

/**
 * Return true if the characters in str, interpreted as a string, start with prefix.
 */
export function charsStartWith(prefix, str) {
    if (prefix.length <= length(str)) {
        return forAll((tupledArg) => (item(tupledArg[0], str) === tupledArg[1]), indexed(prefix.split("")));
    }
    else {
        return false;
    }
}

/**
 * Active pattern helper that matches if a list of chars starts with startP.
 * If it matches the return value is a pair:
 * the first character and the string of characters matching inMatchP
 * the list of chars from the first character that does not match inMatchP.
 * or None if the first character does not match startP.
 * NB - this cannot itself be an active pattern since startP and inMatchP are not literals.
 */
export function makeAPMatch(startP, inMatchP, str) {
    if (!isEmpty(str)) {
        if (startP(head(str))) {
            const unMatchedPart = skipWhile(inMatchP, tail(str));
            return [join("", getSlice(0, (length(str) - length(unMatchedPart)) - 1, str)), unMatchedPart];
        }
        else {
            return undefined;
        }
    }
    else {
        return undefined;
    }
}

/**
 * Returns as many characters not part of any other active pattern match as possible.
 * This must be adjusted to match the otehr active patterns.
 * Note that doing this without a this pattern, using a default for each character, would be
 * inefficient since it would require a match for each character in the string. In addition it would
 * require another pass to common up sequences of characters.
 * However that would make the code more robust, and perhaps it would be better to do this.
 */
export function $007CNormalMatch$007C_$007C(str) {
    const isNormal = (c) => {
        if (c !== "\"") {
            return !isLetterOrDigit(c);
        }
        else {
            return false;
        }
    };
    return makeAPMatch(isNormal, isNormal, str);
}

/**
 * Active Pattern that matches if a char list starts with any of the prefixes in a list.
 * Returns the prefix and the remaining characters if it does.
 * NB - prefixL must be a literal for this to work
 */
export function $007CStringLP$007C_$007C(prefixL, str) {
    return tryPick((prefix) => {
        if (charsStartWith(prefix, str)) {
            return [prefix, getSlice(prefix.length, undefined, str)];
        }
        else {
            return undefined;
        }
    }, prefixL);
}

/**
 * Active Pattern that matches if str starts with a given character.
 * Returns the remaining string if it does.
 * NB - charToMatch must be a literal for this to work
 */
export function $007CCharP$007C_$007C(charToMatch, str) {
    if ((length(str) > 0) && (item(0, str) === charToMatch)) {
        return getSlice(1, undefined, str);
    }
    else {
        return undefined;
    }
}

/**
 * Active Pattern that matches if str starts with a string literal.
 * A string literal is a string starting with a quote and ending with a quote.
 * Returns the non quote part of the string literal and the remainder of str if it does.
 * The closing quote is not removed from str.
 */
export function $007CStringLiteralStart$007C_$007C(str) {
    return makeAPMatch((c) => (c === "\""), (c_1) => (c_1 !== "\""), str);
}

/**
 * Active Pattern that matches if str starts with an identifier.
 * Returns the identifier and the remaining string if it does.
 */
export function $007CIdentifierP$007C_$007C(str) {
    return makeAPMatch((c) => {
        if (isLetter(c)) {
            return true;
        }
        else {
            return c === "_";
        }
    }, (c_1) => {
        if (isLetterOrDigit(c_1)) {
            return true;
        }
        else {
            return c_1 === "_";
        }
    }, str);
}

/**
 * Active Pattern that matches if str starts with a number.
 * Returns the number and the remaining string if it does.
 */
export function $007CNumberP$007C_$007C(str) {
    return makeAPMatch(isDigit, isDigit, str);
}

/**
 * Return chars segmented as a list of strings each paired with a HighlightT.
 * The string is the text to be highlighted and the HighlightT determines the color.
 * HighlightT to color mapping is done in the render function.
 */
export function highlight(chars) {
    let matchResult, keyword, rest, identifier, rest_1, number, rest_2, quote, rest_3;
    if (isEmpty(chars)) {
        matchResult = 0;
    }
    else {
        const activePatternResult = $007CStringLP$007C_$007C(ofArray(["let", "if", "then", "else"]), chars);
        if (activePatternResult != null) {
            matchResult = 1;
            keyword = activePatternResult[0];
            rest = activePatternResult[1];
        }
        else {
            const activePatternResult_1 = $007CIdentifierP$007C_$007C(chars);
            if (activePatternResult_1 != null) {
                matchResult = 2;
                identifier = activePatternResult_1[0];
                rest_1 = activePatternResult_1[1];
            }
            else {
                const activePatternResult_2 = $007CNumberP$007C_$007C(chars);
                if (activePatternResult_2 != null) {
                    matchResult = 3;
                    number = activePatternResult_2[0];
                    rest_2 = activePatternResult_2[1];
                }
                else {
                    const activePatternResult_3 = $007CStringLiteralStart$007C_$007C(chars);
                    if (activePatternResult_3 != null) {
                        const activePatternResult_4 = $007CCharP$007C_$007C("\"", activePatternResult_3[1]);
                        if (activePatternResult_4 != null) {
                            matchResult = 4;
                            quote = activePatternResult_3[0];
                            rest_3 = activePatternResult_4;
                        }
                        else {
                            matchResult = 5;
                        }
                    }
                    else {
                        matchResult = 5;
                    }
                }
            }
        }
    }
    switch (matchResult) {
        case 0:
            return empty();
        case 1:
            return cons([keyword, HighlightT.Keyword], highlight(rest));
        case 2:
            return cons([identifier, HighlightT.Identifier], highlight(rest_1));
        case 3:
            return cons([number, HighlightT.Number$], highlight(rest_2));
        case 4:
            return cons([quote + "\"", HighlightT.String$], highlight(rest_3));
        default: {
            let matchResult_1, quote_1;
            const activePatternResult_5 = $007CStringLiteralStart$007C_$007C(chars);
            if (activePatternResult_5 != null) {
                if (isEmpty(activePatternResult_5[1])) {
                    matchResult_1 = 0;
                    quote_1 = activePatternResult_5[0];
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return singleton([quote_1, HighlightT.String$]);
                default: {
                    const activePatternResult_6 = $007CNormalMatch$007C_$007C(chars);
                    if (activePatternResult_6 != null) {
                        const normalPart = activePatternResult_6[0];
                        const rest_4 = activePatternResult_6[1];
                        return cons([normalPart, HighlightT.Normal], highlight(rest_4));
                    }
                    else if (!isEmpty(chars)) {
                        warnOnce("highlighter-char", `character '${head(chars)}' is not recognised by the highlighter, and is shown as normal text`);
                        return cons([head(chars), HighlightT.Normal], highlight(tail(chars)));
                    }
                    else {
                        throw new MatchFailureException("D:/a/issie-web/issie-web/src/Renderer/UI/Editor.fs", 186, 10);
                    }
                }
            }
        }
    }
}

/**
 * Handles editor mouse events.
 * evtype is the type of event (e.g., click, mousemove).
 * dispatch is the function to call to update the model.
 * ev is the mouse event from the browser.
 */
export function mouseEventHandler(evType, dispatch, ev) {
    const x = ev.clientX;
    const y = ev.clientY;
    const el = document.getElementById("codeEditorContainer");
    const sx = el.scrollLeft;
    const sy = el.scrollTop;
    const bb = el.getBoundingClientRect();
    const x_1 = (((x + sx) - bb.left) - Constants_leftMargin) / 11;
    const y_1 = ((y + sy) - bb.top) / 30;
    if (evType === "click") {
        dispatch(new Msg(/* CodeEditorMsg */ 127, [new EditorMsg(/* SetCursor */ 0, [max(~~(x_1 + 0.5), 0), ~~y_1])]));
    }
}

/**
 * Updates the Editor model with the new cursor position based on mouse coordinates.
 * xMouse and yMouse are the mouse coordinates.
 * xMouse specifies the column position in the line at which new chars are inserted
 * xMouse - 1 is the column that is deleted on backspace.
 * Model is the whole Issie Model - of which CodeEditorModel is one field.
 */
export function updateEditorCursor(xMouse, yMouse, model) {
    const state = defaultArg(model.CodeEditorState, initCodeEditorState);
    const y = max(0, min(length(state.Lines) - 1, yMouse)) | 0;
    return new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, new CodeEditorModel(state.Lines, state.Errors, new XYPos(max(0, min(item(y, state.Lines).length, xMouse)), y)));
}

/**
 * Implements a model update for a key press event.
 * The keyCode is the code of the key pressed.
 * Normally, this is a character code, but it can also be a special key code (e.g., backspace).
 * Character codes are inserted. Special codes are handled differently.
 * Lines and CursorPos are updated accordingly.
 */
export function updateEditorOnKeyPress(keyPress, model) {
    let e_1;
    const state = defaultArg(model.CodeEditorState, initCodeEditorState);
    const key = keyPress.KeyString;
    const modifiers = concat(toList(delay(() => append(keyPress.ShiftKey ? singleton_1(singleton("Shift")) : singleton_1(empty()), delay(() => append(keyPress.ControlKey ? singleton_1(singleton("Control")) : singleton_1(empty()), delay(() => append(keyPress.AltKey ? singleton_1(singleton("Alt")) : singleton_1(empty()), delay(() => (keyPress.MetaKey ? singleton_1(singleton("Meta")) : singleton_1(empty())))))))))));
    const cursorY = max(0, (e_1 = (~~state.CursorPos.Y | 0), min(length(state.Lines) - 1, e_1))) | 0;
    let patternInput;
    const matchValue = length(state.Lines) | 0;
    if (matchValue === 0) {
        patternInput = [empty(), "", empty()];
    }
    else {
        const tupledArg = splitAt(min(cursorY, matchValue), state.Lines);
        const after = tupledArg[1];
        patternInput = [tupledArg[0], item(0, after), getSlice(1, undefined, after)];
    }
    const currentLine = patternInput[1];
    const beforeLines = patternInput[0];
    const afterLines = patternInput[2];
    let cursorX;
    const e_5 = ~~state.CursorPos.X | 0;
    cursorX = min(currentLine.length, e_5);
    let patternInput_1;
    const insertIndex = min(cursorX, currentLine.length) | 0;
    const noChange = append_1(beforeLines, append_1(singleton(currentLine), afterLines));
    const matchValue_1 = equals(modifiers, empty());
    let matchResult, key_3, key_4;
    if (matchValue_1) {
        switch (key) {
            case "Backspace": {
                matchResult = 0;
                break;
            }
            case "Enter": {
                matchResult = 1;
                break;
            }
            default:
                if ((key.length === 1) && !((keyPress.AltKey ? true : keyPress.ControlKey) ? true : keyPress.MetaKey)) {
                    matchResult = 2;
                    key_3 = key;
                }
                else {
                    matchResult = 3;
                    key_4 = key;
                }
        }
    }
    else if ((key.length === 1) && !((keyPress.AltKey ? true : keyPress.ControlKey) ? true : keyPress.MetaKey)) {
        matchResult = 2;
        key_3 = key;
    }
    else {
        matchResult = 3;
        key_4 = key;
    }
    switch (matchResult) {
        case 0: {
            patternInput_1 = (((cursorX === 0) && (cursorY === 0)) ? [cursorX, cursorY, noChange] : ((cursorX === 0) ? [item(cursorY - 1, beforeLines).length, cursorY - 1, append_1(getSlice(undefined, cursorY - 2, beforeLines), append_1(singleton(item(cursorY - 1, beforeLines) + currentLine), afterLines))] : [cursorX - 1, cursorY, append_1(beforeLines, append_1(singleton(join("", removeAt(cursorX - 1, currentLine.split("")))), afterLines))]));
            break;
        }
        case 1: {
            const tupledArg_1 = splitAt(insertIndex, toList(currentLine.split("")));
            patternInput_1 = [0, cursorY + 1, append_1(beforeLines, append_1(ofArray([join("", tupledArg_1[0]), join("", tupledArg_1[1])]), afterLines))];
            break;
        }
        case 2: {
            patternInput_1 = [cursorX + 1, cursorY, append_1(beforeLines, append_1(singleton(insert(currentLine, insertIndex, key_3)), afterLines))];
            break;
        }
        default:
            patternInput_1 = [cursorX, cursorY, noChange];
    }
    return [new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, new CodeEditorModel(patternInput_1[2], defaultArg(model.CodeEditorState, initCodeEditorState).Errors, new XYPos(patternInput_1[0], patternInput_1[1]))), Cmd_none()];
}

/**
 * Renders the line numbers in the left margin of the code editor.
 * xPosition is the X position of the left margin within the scrolling editor div
 * It changes to ensure the left margin stays fixed at the left of the editor.
 * The number of lines is determined by the number of lines in the model.
 */
export function renderLineNumbers(xPosition, model) {
    const props_2 = [new HTMLAttr(/* Id */ 99, ["lineNumberColumn"]), ["style", {
        position: "absolute",
        left: xPosition,
        width: Constants_leftMargin - Constants_leftGutter,
        top: 0,
        lineHeight: 1.5,
        overflowY: "visible",
        overflowX: "visible",
        zIndex: 10000,
        backgroundColor: "#f0f0f0",
    }]];
    const children_2 = map((i) => {
        const props = [new HTMLAttr(/* Id */ 99, [`lineNumber-${i}`]), ["style", {
            position: "absolute",
            left: 0,
            top: (i - 1) * 30,
            width: Constants_leftMargin - Constants_leftGutter,
            height: "30px",
            textAlign: "right",
            backgroundColor: "#f0f0f0",
            paddingRight: "5px",
        }]];
        const children = [toText(printf("%d"))(i)];
        return react.createElement("div", keyValueList(props, 1), ...children);
    }, toList(rangeDouble(1, 1, max(length(model.Lines), 1))));
    return react.createElement("div", keyValueList(props_2, 1), ...children_2);
}

/**
 * Type of data  passed to the line render function from the main render function.
 * This is a subset of CodeEditorModel data and derived from this.
 */
export class LineData extends Record {
    constructor(LineIndex, LineText, CursorX, Errors) {
        super();
        this.LineIndex = (LineIndex | 0);
        this.LineText = LineText;
        this.CursorX = CursorX;
        this.Errors = Errors;
    }
}

export function LineData_$reflection() {
    return record_type("Editor.LineData", [], LineData, () => [["LineIndex", int32_type], ["LineText", string_type], ["CursorX", option_type(int32_type)], ["Errors", list_type(Interval_$reflection())]]);
}

/**
 * Renders a single line of code in the editor, with optional cursor and error indication.
 */
export function renderOneEditorLine(data) {
    let f1_1, f1, other, props_4, reactOfText, props_16, props_18;
    const text = data.LineText;
    const lineIndex = data.LineIndex | 0;
    const cursorX = data.CursorX;
    let errorLineReact;
    const _arg = sort(collect((f1_1 = ((f1 = ((other = (new Interval(new XYPos(0, lineIndex), new XYPos(text.length + 1, lineIndex))), (this$) => intersectionOpt(other, this$))), (arg) => {
        let interval;
        const option_1 = f1(arg);
        return (option_1 != null) ? ((interval = option_1, [~~interval.Start.X, ~~interval.End.X])) : undefined;
    })), (arg_1) => ofArray(toArray(f1_1(arg_1)))), data.Errors), {
        Compare: (x, y) => (compareArrays(x, y) | 0),
    });
    if (isEmpty(_arg)) {
        errorLineReact = empty();
    }
    else {
        const errorLineReactL = mapIndexed((i, tupledArg_3) => {
            const spaceChars = replicate(tupledArg_3[1], "*");
            if (tupledArg_3[0]) {
                const props = [new HTMLAttr(/* Id */ 99, [`errorseg-${lineIndex}-${i}`]), ["style", {
                    textDecoration: "underline wavy red",
                    textUnderlineOffset: "15%",
                    position: "relative",
                }]];
                return react.createElement("span", keyValueList(props, 1), spaceChars);
            }
            else {
                const props_2 = [new HTMLAttr(/* Id */ 99, [`okseg-${lineIndex}-${i}`]), ["style", {
                    position: "relative",
                }]];
                return react.createElement("span", keyValueList(props_2, 1), spaceChars);
            }
        }, reverse(fold((tupledArg, tupledArg_1) => {
            const start = tupledArg[0] | 0;
            const errStart = tupledArg_1[0] | 0;
            const errEnd = tupledArg_1[1] | 0;
            const okSeg = ((errStart - 1) < start) ? undefined : [false, errStart - start];
            return [errEnd + 1, concat([ofArray(toArray((errStart > errEnd) ? undefined : [true, errEnd - errStart])), ofArray(toArray(okSeg)), tupledArg[1]])];
        }, [0, empty()], _arg)[1]));
        errorLineReact = singleton((props_4 = [new HTMLAttr(/* Id */ 99, [`errorSegLine-${lineIndex}`]), ["style", {
            position: "absolute",
            left: 0,
            top: 0,
            whiteSpace: "pre",
            verticalAlign: "middle",
            background: "transparent",
            color: "transparent",
            lineHeight: 1.5,
        }]], react.createElement("div", keyValueList(props_4, 1), ...errorLineReactL)));
    }
    const children_18 = concat([(reactOfText = ((text === "") ? singleton(react.createElement("br", {})) : map((tupledArg_4) => {
        const text_2 = tupledArg_4[0];
        const elementType = tupledArg_4[1];
        switch (elementType.tag) {
            case 1: {
                const props_8 = [["style", {
                    color: "green",
                }]];
                return react.createElement("span", keyValueList(props_8, 1), text_2);
            }
            case 2: {
                const props_10 = [["style", {
                    color: "blue",
                }]];
                return react.createElement("span", keyValueList(props_10, 1), text_2);
            }
            case 3: {
                const props_12 = [["style", {
                    color: "orange",
                }]];
                return react.createElement("span", keyValueList(props_12, 1), text_2);
            }
            case 4: {
                const props_14 = [["style", {
                    color: "red",
                }]];
                return react.createElement("span", keyValueList(props_14, 1), text_2);
            }
            default:
                return text_2;
        }
    }, highlight(toList(text.split(""))))), singleton((props_16 = [new HTMLAttr(/* Id */ 99, [toText(printf("code-text-line-%d"))(lineIndex)]), ["style", {
        position: "absolute",
        verticalAlign: "middle",
        scrollSnapAlign: "start",
        lineHeight: 1.5,
        left: 0,
        top: 0,
        whiteSpace: "pre",
        background: "transparent",
    }]], react.createElement("span", keyValueList(props_16, 1), ...reactOfText)))), errorLineReact, (cursorX == null) ? empty() : singleton((props_18 = [new HTMLAttr(/* Id */ 99, ["cursor-div"]), ["style", {
        position: "absolute",
        left: (cursorX * 11) - 9.5,
        top: 0,
        lineHeight: 1.5,
        background: "transparent",
        animation: "codeEditorBlink 1s steps(2, start) infinite",
    }]], react.createElement("div", keyValueList(props_18, 1), "⌶")))]);
    const props_20 = ofArray([new HTMLAttr(/* Id */ 99, ["codeEditorLine"]), ["style", {
        position: "absolute",
        left: Constants_leftMargin,
        top: lineIndex * 30,
        lineHeight: 0,
        whiteSpace: "pre",
    }]]);
    return react.createElement("div", keyValueList(props_20, 1), ...children_18);
}

/**
 * Renders the complete code editor with syntax highlighting and error indication.
 * The editor is rendered in a div with a fixed size as specified in the CSS Height and Width props.
 * The height of the editor is rounded to fit an integral number of lines.
 * The editor is scrollable in both X and Y directions.
 * CoceEditorModel is the model for the code editor, and includes info
 * about the lines of code, the cursor position, and any errors.
 */
export function renderEditor(model, dispatch) {
    const lines = mapIndexed((lineIndex, text) => {
        const functionToMemoize = renderOneEditorLine;
        const key_1 = (props) => (`${props.LineIndex}`);
        const props_2 = new LineData(lineIndex, text, (lineIndex === ~~model.CursorPos.Y) ? ~~model.CursorPos.X : undefined, model.Errors);
        if (key_1 != null) {
            const key_1_1 = key_1;
            return FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value("D:\\a\\issie-web\\issie-web\\src\\Renderer\\UI\\Editor.fs") + "#L") + int32ToString(value(51))) + ";") + "Editor.LineData", "codeEditorLine", functionToMemoize, Helpers_equalsButFunctions, key_1_1, "Of")(props_2);
        }
        else {
            return FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value("D:\\a\\issie-web\\issie-web\\src\\Renderer\\UI\\Editor.fs") + "#L") + int32ToString(value(49))) + ";") + "Editor.LineData", "codeEditorLine", functionToMemoize, Helpers_equalsButFunctions, undefined, "Of")(props_2);
        }
    }, model.Lines);
    const scrollContainer = document.getElementById("codeEditorContainer");
    const hasXScroll = !equals(scrollContainer, defaultOf()) && (scrollContainer.scrollWidth > scrollContainer.clientWidth);
    const xScrollbarHeightPx = (equals(scrollContainer, defaultOf()) ? true : !hasXScroll) ? 0 : (scrollContainer.offsetHeight - scrollContainer.clientHeight);
    const xScrollAmount = equals(scrollContainer, defaultOf()) ? 0 : scrollContainer.scrollLeft;
    const props_3 = [new HTMLAttr(/* Id */ 99, ["codeEditorContainer"]), new DOMAttr(/* OnClick */ 40, [(ev) => {
        mouseEventHandler("click", dispatch, ev);
    }]), new DOMAttr(/* OnMouseMove */ 54, [(ev_1) => {
        mouseEventHandler("mousemove", dispatch, ev_1);
    }]), new DOMAttr(/* OnScroll */ 63, [(ev_2) => {
        dispatch(new Msg(/* CodeEditorMsg */ 127, [new EditorMsg(/* UpdateCodeEditorState */ 3, [(x_2) => x_2])]));
    }]), ["style", {
        fontFamily: "monospace",
        fontSize: "20px",
        lineHeight: "0",
        borderTop: "0px",
        paddingTop: "0px",
        paddingBottom: "0px",
        borderBottom: "0px",
        position: "relative",
        overflowY: "auto",
        overflowX: "auto",
        scrollSnapType: "y mandatory",
        height: `calc( round(50vh , 45px) + ${xScrollbarHeightPx}px)`,
        width: "50vw",
    }]];
    const children = cons(renderLineNumbers(xScrollAmount, model), lines);
    return react.createElement("div", keyValueList(props_3, 1), ...children);
}

/**
 * Main editor model update function, called from Elmish main update when a CodeEditorMsg Message is received.
 * This allows additional Code Editor messages to be added here in the future without changing
 * the main update function. Note that the message type must still be changed in ModelType.fs since F#
 * does not support forward type references even to an opaque type.
 * NB - There is a way to get forward references - by parametrising the Model type - that is
 * theoretically neat, and possible, but in practice it is too messy to implement because type parameters
 * would then decorate the whole code base.
 */
export function update(editorMsg, model) {
    const state = defaultArg(model.CodeEditorState, initCodeEditorState);
    return [(editorMsg.tag === 1) ? (new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, new CodeEditorModel(editorMsg.fields[0](state.Lines), state.Errors, state.CursorPos))) : ((editorMsg.tag === 2) ? (new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, new CodeEditorModel(state.Lines, editorMsg.fields[0], state.CursorPos))) : ((editorMsg.tag === 3) ? (new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, model.CurrentProj, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, editorMsg.fields[0](state))) : updateEditorCursor(editorMsg.fields[0], editorMsg.fields[1], model))), Cmd_none()];
}

export const testEditorModel = (() => {
    const errorPosns = ofArray([new Interval(new XYPos(3, 1), new XYPos(4, 1)), new Interval(new XYPos(0, 0), new XYPos(4, 0)), new Interval(new XYPos(4, 10), new XYPos(6, 11))]);
    return new CodeEditorModel(append_1(ofArray(["   if then else module 123 yellow Big!", "a  test 5 ", "     ;   ;"]), replicate_1(200 - 3, "test2 bbbb 1234 () \"abcdef\" 6754 (Ta123) ")), errorPosns, new XYPos(10, 0));
})();

